import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { IMenuBase } from "@/interfaces/IMenu";
import { cn } from "@/lib/utils";
import { type SelectProps } from "@radix-ui/react-select";
import { ListFilter } from "lucide-react";

export interface DropdownSelectProp extends SelectProps {
  triggerClassName?: string;
  contentClassName?: string;
  title?: string;
  contentAlign?: "center" | "end" | "start";
  menuList: IMenuBase[];
}

export function DropdownSelect({
  title,
  menuList,
  contentClassName,
  triggerClassName,
  contentAlign,
  ...props
}: DropdownSelectProp) {
  return (
    <Select {...props}>
      <SelectTrigger
        className={cn(
          "text-primary gap-1 justify-center w-[148px] bg-button-fillter list-none border-none backdrop-blur-lg shadow-[0px_28px_20px_-27px_rgba(0,0,0,0.15)] h-[56px] px-6 !rounded-[30px] [&>svg]:text-[#0F1324]/[0.6] [&>svg]:opacity-100",
          triggerClassName,
        )}
      >
        <div className="flex gap-1 text-primary flex-1 !text-sm !font-medium leading-caption-l tracking-caption-l">
          <ListFilter color="#0F132499" size={20} />
          <SelectValue placeholder={title} />
        </div>
      </SelectTrigger>
      <SelectContent
        align={contentAlign}
        className={cn(
          "mt-2 rounded-[16px] border border-[#FFEDF7] p-2",
          contentClassName,
        )}
      >
        {menuList.map((e) => (
          <SelectItem
            key={`select-item-${e.id}`}
            className="hover:bg-base-tertiary/[0.04] focus:bg-base-tertiary/[0.04] rounded-[8px] text-primary font-medium leading-caption-l tracking-caption-l p-2"
            value={e.id}
          >
            <div className="flex gap-2">
              {e.icon ? e.icon : null}
              <h1>{e.label}</h1>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
